exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4.card-title {\r\n\tmargin: 0;\r\n\tfont-family: \"Open Sans\";\r\n\tfont-size: 1rem;\r\n}\r\n\r\n.card-header {\r\n\tpadding: 0;\r\n}\r\n\r\n.c-validation{\r\n    background: #c51244 !important;\r\n    padding: 4px !important;\r\n    border-radius: 5px !important;\r\n    position: relative;\r\n    display: inline-block !important;\r\n    -webkit-box-shadow: 6px 6px 8px #4f4a4a;\r\n            box-shadow: 6px 6px 8px #4f4a4a;\r\n    margin-top: 0px;\r\n   font-size: 14px;\r\n   z-index: 100;\r\n   color: white;\r\n\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/fixed-deposit/fixed-deposit.component.css
// module id = ../../../../../src/app/fixed-deposit/fixed-deposit.component.css
// module chunks = main